// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.loading-page {
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
}
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.loading__text {
  font-weight: 600;
  font-size: 28px;
  text-align: center;
  white-space: pre-wrap;
  padding: 0 24px;
}
.loading__image.\\--default {
  width: 120px;
}
.loading__image.\\--house {
  width: 140px;
}`, "",{"version":3,"sources":["webpack://./src/styles/dist/sage/loading.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd","sourcesContent":["/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.loading-page {\n  display: flex;\n  height: 100vh;\n  align-items: center;\n  justify-content: center;\n}\n\n.loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.loading__text {\n  font-weight: 600;\n  font-size: 28px;\n  text-align: center;\n  white-space: pre-wrap;\n  padding: 0 24px;\n}\n.loading__image.\\--default {\n  width: 120px;\n}\n.loading__image.\\--house {\n  width: 140px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
